/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown, MenuProps } from "antd";
import React, { useState } from "react";
import { DropdownMenuWrapper } from "../../common/DropdownMenuWrapper";
import { DropdownItemLink } from "../../common/DropdownItemLink";
import { MenuRecommendedProduct } from "../models/Menus";
import { ellipsisStyle } from "./MenuDropdown";
import { routes } from "../../../appRoutingHelpers";
import { useSelector } from "react-redux";
import * as authSelectors from "../../auth/authSelectors";
import { RemoveRecommendedProductSelector } from "./RemoveRecommendedProductSelector";

type Props = {
  recommendedProduct: MenuRecommendedProduct;
  menuId?: string;
  recommendedProducts: MenuRecommendedProduct[];
};

export const RecommendedProductDropdown = ({
  recommendedProduct,
  menuId,
  recommendedProducts,
}: Props) => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const [open, setOpen] = useState<boolean>(false);
  const productEditLink = routes.productEdit(
    organizationKeyName,
    recommendedProduct.product.id
  );
  const items: MenuProps["items"] = [
    {
      key: "1",
      label: (
        <DropdownItemLink
          to={productEditLink}
          icon={<FontAwesomeIcon icon={solid("arrow-up-right-from-square")} />}
        >
          Go to product
        </DropdownItemLink>
      ),
    },
    {
      key: "2",
      label: (
        <RemoveRecommendedProductSelector
          menuId={menuId}
          id={recommendedProduct.id}
          recommendedProducts={recommendedProducts}
        />
      ),
    },
  ];

  const dropdownInnerWrapper = css`
    display: flex;
    flex-direction: column;
    padding: 8px;
  `;

  return (
    <Dropdown
      menu={{
        items: items,
      }}
      open={open}
      onOpenChange={setOpen}
      placement="bottomRight"
      dropdownRender={(menu) => (
        <DropdownMenuWrapper>
          <div css={dropdownInnerWrapper}>
            {React.cloneElement(menu as React.ReactElement, {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                boxShadow: "none",
                padding: "0px",
                backgroundColor: "transparent",
              },
            })}
          </div>
        </DropdownMenuWrapper>
      )}
    >
      <div css={ellipsisStyle}>
        <FontAwesomeIcon icon={solid("ellipsis")} />
      </div>
    </Dropdown>
  );
};
